module.exports = __webpack_public_path__ + "static/media/I.Eliyev.f5caf14f.jpg";